
<div class="list-group-item border-0" >
<app-simple-qstn  [q]=q [i]=i> </app-simple-qstn>

<app-ansr-view class = "" [showA] =false [q]=q [i]=i> </app-ansr-view>

</div>
